import React from "react";
import { Reveal } from "./Reveal";
import { MANIFESTO, WHY_DIFFERENT } from "../../data/content";

export const Manifesto = () => (
  <section id="manifesto" className="relative py-24 md:py-40 border-t border-brand-line" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="overline mb-6">01 — The Company</p>
        <h2 className="font-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tight text-brand-text max-w-3xl leading-[1.02]">
          We build the people who build organizations.
        </h2>
      </Reveal>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 border-t border-brand-line">
        {MANIFESTO.map((m, i) => (
          <Reveal
            key={m.no}
            delay={i * 0.12}
            className={`py-12 md:py-16 md:px-10 border-b border-brand-line md:border-b-0 ${
              i !== 0 ? "md:border-l md:border-brand-line" : "md:pl-0"
            }`}
          >
            <span className="font-display text-6xl md:text-7xl text-brand/90 font-light">{m.no}</span>
            <h3 className="mt-6 font-display text-3xl md:text-4xl text-brand-text">{m.title}</h3>
            <p className="mt-5 text-brand-soft leading-relaxed font-light">{m.body}</p>
          </Reveal>
        ))}
      </div>

      <div className="mt-24 grid grid-cols-1 lg:grid-cols-[0.4fr_0.6fr] gap-10 lg:gap-20">
        <Reveal>
          <p className="overline mb-4">Why we&apos;re different</p>
          <p className="font-display text-2xl md:text-3xl text-brand-text leading-snug font-light">
            A rare blend of local insight and international standard.
          </p>
        </Reveal>
        <div>
          {WHY_DIFFERENT.map((w, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="flex items-baseline gap-6 py-6 border-b border-brand-line group">
                <span className="font-mono text-xs text-brand-muted">{String(i + 1).padStart(2, "0")}</span>
                <p className="text-brand-text/90 text-lg md:text-xl font-light group-hover:text-brand transition-colors duration-300">{w}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Manifesto;
